export default __webpack_public_path__ + "static/media/logo.1abbc6c1.svg";